import { Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';
import { LocalStoreService } from '@frontend/vanilla/core';

import { HELP_BOX_TYPE } from '../../../help-box/help-box-type';

@Component({
    selector: 'ms-help-box-re-bet',
    templateUrl: './help-box-re-bet.html',
    standalone: false,
})
export class HelpBoxReBetComponent {
    @Input() listType: BetslipListType | undefined;
    private reBetHelpBoxStorageKeySettledTab = 'reBetHelpBoxClosedSettledTab';
    private reBetHelpBoxStorageKeyForOpenTab = 'reBetHelpBoxClosedOpenTab';

    constructor(
        public sitecore: Sitecore,
        private localStorage: LocalStoreService,
    ) {}

    onReBetHelpBoxClose = () => {
        this.localStorage.set(
            this.listType && this.listType === BetslipListType.Open ? this.reBetHelpBoxStorageKeyForOpenTab : this.reBetHelpBoxStorageKeySettledTab,
            true,
        );
    };

    get isReBetHelpBoxVisible(): boolean {
        return !this.localStorage.get(
            this.listType && this.listType === BetslipListType.Open ? this.reBetHelpBoxStorageKeyForOpenTab : this.reBetHelpBoxStorageKeySettledTab,
        );
    }

    get reBetHelpBoxType(): string {
        return this.listType && this.listType === BetslipListType.Open ? HELP_BOX_TYPE.ReBetForOpenTab : HELP_BOX_TYPE.ReBet;
    }
}
